import moment, { MomentInput } from "moment";

import {
  DATE_DAY_MONTH,
  DATE_MONTH_YEAR,
  DEFAULT_DATE_FORMAT,
  ISO_DATE_FORMAT,
  ISO_DATE_TIME_FORMAT,
  ISO_DATE_TIME_FORMAT_NO_OFFSET,
  ISO_TIME_FORMAT,
  TIME_FORMAT_12H,
  TIME_FORMAT_24H
} from "./date";

export type FormatFunction = (rawDate?: MomentInput) => string;
export type LocalizedFormatFunction = (rawDate?: MomentInput, locale?: string) => string;

export type DateFormatter = {
  dateFormatString: string;
  dateTimeFormatString: string;
  timeFormatString: string;
  formatDate: LocalizedFormatFunction;
  formatDateTime: LocalizedFormatFunction;
  formatISOTime: FormatFunction;
  formatISODate: FormatFunction;
  formatISODateTime: FormatFunction;
  formatDatabaseDateTime: FormatFunction;
  formatShortMonth: FormatFunction;
  formatLongMonth: FormatFunction;
  formatLongDate: FormatFunction;
  formatMonthYear: FormatFunction;
  formatDay: FormatFunction;
  formatDayMonth: FormatFunction;
  formatDateWithMonthNames: FormatFunction;
};

export const dateFormatter: (dateFormat?: string, isAM?: boolean) => DateFormatter = (
  dateFormat = ISO_DATE_FORMAT,
  isAM = false
) => {
  const timeFormat = isAM ? TIME_FORMAT_12H : TIME_FORMAT_24H;
  const dateTimeFormatString = `${dateFormat}, ${timeFormat}`;

  return {
    dateFormatString: dateFormat,
    dateTimeFormatString,
    timeFormatString: timeFormat,
    formatDate: (rawDate, locale?: string) =>
      moment(rawDate)
        .locale(locale || moment.locale())
        .format(dateFormat),
    formatDateTime: (rawDate, locale?: string) =>
      moment(rawDate)
        .locale(locale || moment.locale())
        .format(dateTimeFormatString),
    formatISOTime: (rawTime) => moment.utc(rawTime).format(ISO_TIME_FORMAT),
    // TODO: [SP-1571] Fix the time zone issue in the date formatter globally
    formatISODate: (rawDate) => moment(rawDate).format(ISO_DATE_FORMAT),
    formatISODateTime: (rawDate) => moment(rawDate).format(ISO_DATE_TIME_FORMAT_NO_OFFSET),
    formatDatabaseDateTime: (rawDate) => moment.utc(rawDate).format(ISO_DATE_TIME_FORMAT),
    formatDateWithMonthNames: (rawDate) => moment(rawDate).format(DEFAULT_DATE_FORMAT),
    formatShortMonth: (rawDate) => moment(rawDate).format("MMM"),
    formatLongMonth: (rawDate) => moment(rawDate).format("MMMM"),
    formatLongDate: (rawDate) => moment(rawDate).format("LL"),
    formatMonthYear: (rawDate) => moment(rawDate).format(DATE_MONTH_YEAR),
    formatDay: (rawDate) => moment(rawDate).format("DD"),
    formatDayMonth: (rawDate) => moment(rawDate).format(DATE_DAY_MONTH)
  };
};
